import { saveSpreadsheet } from '../../utils/spreadsheet/save';

export type ActivityAnalyticsEntry = {
  id: number;
  firstName?: string;
  lastName?: string;
  internalId?: string;
  pictureUrl?: string;
  phoneNumber?: string;
  email?: string;
  startDate?: string;
  departmentName: string;
  jobTitleName: string;
  regionName: string;
  /**
   * @deprecated use {@link AdminUserDto.units}
   */
  unitIds: number[];
  units: string[];
  roles: string[];
  disabledFrom?: string;
  activityStatus: 'opened' | 'done' | 'not-started';
  activityStartedAt: string | undefined;
  activityMarkedAsDoneAt: string | undefined;
};

export const createActivityAnalyticsListExporter = (params: {
  journeyName: string;
  sectionName: string;
  activityName: string;
}) => {
  return async (analyticsEntries: ActivityAnalyticsEntry[]) => {
    const mapped = analyticsEntries.map((entry: ActivityAnalyticsEntry) => {
      return {
        ['ID']: entry.id,
        ['Internal ID']: entry.internalId,
        ['First Name']: entry.firstName,
        ['Last Name']: entry.lastName,
        ['Job Title']: entry.jobTitleName,
        ['Department']: entry.departmentName,
        ['Region']: entry.regionName,
        ['Unit']: entry.units.join(', '),
        ['Activity Status']: entry.activityStatus,
        ['Activity Started At']: entry.activityStartedAt,
        ['Activity Marked As Done At']: entry.activityMarkedAsDoneAt,
      };
    });

    await saveSpreadsheet({
      format: 'csv',
      data: mapped,
      basename: `${params.journeyName} - ${params.sectionName} - ${params.activityName} - Analytics`,
    });
  };
};
